import resetGFieldError from "./reset-gfield-error";
import resetPersonalIdentityNumber from "./reset-personal-identity-number";

export default function resetField(fieldElement) {
  resetGFieldError(fieldElement);
  const inputs = fieldElement.querySelectorAll('.gform-marknadsinformation-input');
  inputs.forEach(function(input) {
    if (input.id.endsWith('.1')) {
      resetPersonalIdentityNumber(input);
    }
    input.value = '';
    input.readOnly = false;
  });
  resultElement.classList.add('bravo-marknadsinformation-gf__result--hidden');
  resultElement.classList.remove('bravo-marknadsinformation-gf__result--loading');
  resultElement.innerHTML = '';
  
  const validation = document.getElementById( fieldElement.id + '_validation' );
  validation.value = 0;
  
}